import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/ui/alert-dialog";
import { useToast } from "../../../hooks/use-toast";
import { Role } from "../../../types";
import { useDeleteRole } from "../hooks/use-role-queries";

interface DeleteRoleDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  role: Role | null;
  onSuccess?: () => void;
}

export function DeleteRoleDialog({
  open,
  onOpenChange,
  role,
  onSuccess,
}: DeleteRoleDialogProps) {
  const { toast } = useToast();
  const deleteRole = useDeleteRole();

  const handleDelete = async () => {
    if (!role) return;

    try {
      await deleteRole.mutateAsync(role.id);
      toast({
        title: "Sucesso",
        description: "Função excluída com sucesso!",
      });
      onOpenChange(false);
      onSuccess?.();
    } catch (error: any) {
      toast({
        title: "Erro",
        description: error?.message || "Erro ao excluir a função",
        variant: "destructive",
      });
      console.error("Error deleting role:", error);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Você tem certeza disso?</AlertDialogTitle>
          <AlertDialogDescription>
            Isso irá excluir permanentemente a função{" "}
            <strong>{role?.name}</strong> ({role?.ops}) e removê-la de todos os
            usuários que a possuem. Essa ação não pode ser desfeita.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleteRole.isPending}>
            Cancelar
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            disabled={deleteRole.isPending}
            className="bg-red-600 hover:bg-red-700"
          >
            {deleteRole.isPending ? "Excluindo..." : "Excluir Função"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
